import React from 'react'
import Tooltip from 'antd/es/tooltip'

export type Position = 'top' | 'bottom' | 'left' | 'right'

export type Size = 'large' | 'medium' | 'small' | 'tiny' | 'veryTiny'

type Props = {
    title?: string | React.ReactElement
    position?: Position
    size?: Size
    overlayClassName?: string
}

// Size factors match the 12x12, 16x16, 24x24, 32x32 and 40x40 icon dimensions from: https://www.figma.com/design/BpMdzCsfZAXmpHQCowcsWD/Global-Design-Library-(Master-%40-7f17203)?node-id=5777-113734&m=dev
const sizeFactor: Record<Size, number> = {
    veryTiny: 0.5, // 12x12
    tiny: 1, // 16x16
    small: 2,
    medium: 3,
    large: 4,
}

export const InfoPopover = (props: Props) => {
    const placement = props.position || 'top'
    return (
        <Tooltip
            title={props.title}
            arrow={{ pointAtCenter: true }}
            color="var(--teal-500)"
            placement={placement}
            overlayClassName={props.overlayClassName}
            overlayInnerStyle={{ padding: '1.2rem 2.0rem' }}
            overlayStyle={{ fontFamily: 'var(--Info-Popover-font-family, inherit)' }}
        >
            <zaptic-icon
                icon-name="info"
                class="AppCore__InfoPopover"
                style={
                    {
                        ...(props.size && { '--icon-size-factor': sizeFactor[props.size] }),
                    } as React.CSSProperties
                }
            />
        </Tooltip>
    )
}
